import React, { ReactElement } from 'react'

const ConfigureIcon: React.FC = (): ReactElement => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        version='1.1'
        id='Layer_2'
        x='0px'
        y='0px'
        viewBox='0 0 22 22'
        strokeWidth='2'
        strokeMiterlimit='10'
    >
        <line style={{ fill: 'none', stroke: '#4D4D4D' }} x1='4' y1='19' x2='4' y2='22' />
        <line style={{ fill: 'none', stroke: '#4D4D4D' }} x1='4' y1='0' x2='4' y2='13' />
        <line style={{ fill: 'none', stroke: '#4D4D4D' }} x1='11' y1='9' x2='11' y2='22' />
        <line style={{ fill: 'none', stroke: '#4D4D4D' }} x1='11' y1='0' x2='11' y2='3' />
        <line style={{ fill: 'none', stroke: '#4D4D4D' }} x1='18' y1='19' x2='18' y2='22' />
        <line style={{ fill: 'none', stroke: '#4D4D4D' }} x1='18' y1='0' x2='18' y2='13' />
        <circle style={{ fill: 'none', stroke: '#4D4D4D' }} cx='11' cy='6' r='3' />
        <circle style={{ fill: 'none', stroke: '#4D4D4D' }} cx='4' cy='16' r='3' />
        <circle style={{ fill: 'none', stroke: '#4D4D4D' }} cx='18' cy='16' r='3' />
    </svg>
)
export default ConfigureIcon
